import { render, staticRenderFns } from "./companyPlansInfo.vue?vue&type=template&id=525028e6"
import script from "./companyPlansInfo.vue?vue&type=script&lang=js"
export * from "./companyPlansInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports